import React, { useState } from "react";
import CallModal from "./CallModal";

const FloatingCallButton = () => {

    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                className="floating-call-btn"
                onClick={() => setOpen(true)}
            >
                📞
            </button>

            <CallModal open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default FloatingCallButton;